import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Enums } from '../../../shared/enums';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class FooterComponent implements OnInit {
    // #region [Type props]
    Enums = Enums;
    // #endregion

    // #region [props]
    isFromConecta = false;
    // #endregion

    constructor(private cookieService: CookieService) {
        if (atob(this.cookieService.get('prodest-eflow-cnc')).toLowerCase() == 'true') {
            this.isFromConecta = window.location.pathname.includes(Enums.PagesPaths.CatalogService);
        }
    }

    ngOnInit() { }

    // #region [===== private methods =====]
    // #endregion
}
